import themeConfig from "./themeConfig";

function toMonthDay(value) {
  if (!value) return null;
  if (/^\d{2}-\d{2}$/.test(value)) {
    const [m, d] = value.split("-").map(Number);
    return { month: m, day: d, year: null };
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return { month: m, day: d, year: y };
  }
  return null;
}

function toComparable(dateObj) {
  return dateObj.month * 100 + dateObj.day;
}

function isWithinRange(date, start, end) {
  if (!start || !end) return false;

  const dateValue = date.getMonth() * 100 + date.getDate() + 101;
  const startValue = toComparable(start);
  const endValue = toComparable(end);

  if (start.year && end.year) {
    const dateStr = date.toISOString().slice(0, 10);
    const startStr = `${start.year}-${String(start.month).padStart(2, "0")}-${String(
      start.day
    ).padStart(2, "0")}`;
    const endStr = `${end.year}-${String(end.month).padStart(2, "0")}-${String(
      end.day
    ).padStart(2, "0")}`;
    return dateStr >= startStr && dateStr <= endStr;
  }

  if (startValue <= endValue) {
    return dateValue >= startValue && dateValue <= endValue;
  }

  return dateValue >= startValue || dateValue <= endValue;
}

export function getActiveTheme(date = new Date()) {
  const themes = themeConfig?.themes ?? [];

  for (const theme of themes) {
    const start = toMonthDay(theme.start);
    const end = toMonthDay(theme.end);

    if (isWithinRange(date, start, end)) {
      return theme;
    }
  }

  return null;
}

export function getActiveThemeLogo(date = new Date()) {
  const theme = getActiveTheme(date);
  return theme?.logo || themeConfig.defaultLogo;
}
